module.exports = __webpack_public_path__ + "static/media/5.16691436.jpg";